var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('title',[_vm._v("Edit")]),_c('polygon',{attrs:{"points":"19.5 6.87 4.5 6.87 10.21 12.23 10.21 17.82 13.79 19.86 13.79 12.23 19.5 6.87"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }